const carRental = {
  carRental: "Car Rental",
  carRentals: "Car Rentals",
  pickUpPoint: "Pick-up Point",
  dropOffPoint: "Drop-off Point",
  pleaseSelectAPickUpPoint: "Please select a Pick-up Point",
  pickUpDate: "Pick-up Date",
  dropOffDate: "Drop-off Date",
  pickUp: "Pick-up",
  dropOff: "Drop-off",
  edit: "Edit",
  fuelPolicy: "Fuel Policy",
  pickUpLocation: "Pick-up Location",
  mileage: "Mileage",
  transmission: "Transmission",
  airCondition: "Air Condition",
  minimumAge: "Minimum Age",
  maximumAge: "Maximum Age",
  providerAddress: "Provider Address",
  providerPhone: "Provider Phone",
  driverInfo: "Driver Info",
  driversInfo: "Driver's Info",
  differentDropOff: "Drop-off at different location",
  maxPassengers: "Max Passengers",
  budget: "Budget",
  provider: "Provider",
  carModel: "Car Model",
  numOfDoors: "Num Of Doors",
  fuelType: "Fuel Type",
  driverAge: "Driver's Age",
  enterValidDriversAge: "Please enter a valid Driver's Age.",
  workingHours: "Working Hours",
  driverNationality: "Driver's Nationality",
  nationalityIsRequired: "Nationality is required",
  carRentalRate: "Car Rental Rate",
  dueNow: "Due Now",
  duePickUp: "Due at Pick-up",
  toViewOfferPDF:
    "To view a PDF document containing all rental terms of this offer, please",
  toViewTermsAndCondPDF:
    "To view the applicable CARNECT Terms and Conditions, please",
  carRentalsNotFound:
    "We couldn't find any Car Rental results. We are sorry for inconvenience",
};

export default carRental;
